import { Component, Renderer2 } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { ViewController } from 'ionic-angular';

@Component({
  selector: 'simple-message-modal',
  templateUrl: 'simple-message-modal.html',
})
export class SimpleMessageModalComponent {
  title: string;
  description: string;
  actionButtonText: string;

  constructor(
    private navParams: NavParams,
    private viewCtrl: ViewController,
    private renderer: Renderer2
  ) {
    this.renderer.addClass(
      this.viewCtrl.pageRef().nativeElement,
      'simple-message-modal'
    );
    this.renderer.addClass(
      this.viewCtrl.pageRef().nativeElement,
      'app-yoshi-modal'
    );
    this.title = this.navParams.get('title');
    this.description = this.navParams.get('description');
    this.actionButtonText = this.navParams.get('actionButtonText');
  }

  ngAfterViewInit() {
    this.fixModalHeight();
  }

  didTapModalAction() {
    this.viewCtrl.dismiss();
  }

  private fixModalHeight() {
    const descriptionEle = document.querySelector(
      '.simple-message-modal > .simple-message-modal__description'
    );
    const modalWrapper = document.querySelector(
      '.simple-message-modal > .modal-wrapper'
    );
    const actionBtnHeight = 45;
    const paddingBottom = 20;
    if (descriptionEle && modalWrapper) {
      let descriptionHeight = descriptionEle['offsetHeight'];
      if (descriptionHeight > 300) {
        descriptionHeight = 300;
        descriptionEle['style'].overflowY = 'scroll';
      }
      modalWrapper['style'].height =
        descriptionHeight +
        (modalWrapper['offsetHeight'] - (actionBtnHeight + paddingBottom)) +
        'px';
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/simple-message-modal/simple-message-modal.ts